// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ojdktjavsdgcjavmrsyc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9qZGt0amF2c2RnY2phdm1yc3ljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5MjU3MzIsImV4cCI6MjA2OTUwMTczMn0.tKXwBEFOlzzmvC3P6086Crzpv-6pV6LlefmM4yCAprE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});